import { ExcelTool } from '../excel/excel_tool';
import { StructureService } from '../../services/structure_service';
// import { lazyInject } from '../../services/inversify';
import {provideSingleton, lazyInject} from '../../services/inversify';
//
@provideSingleton(ImportRoutine)
//
// ***************************** IMPORT ROUTINEN ***********************************
export class ImportRoutine {

    @lazyInject(StructureService) private structureService: StructureService;

    process(dataIn: any, modul: string, ignoreRows: number) {
        const headerRow = dataIn.headerRow;
        const sheetData: Array<any> = (dataIn.sheetDataAll || {})[dataIn.sheetName] || [];
        let headerRowData: Array<any>;
        let firstRow: any;
        if (Array.isArray(headerRow)) {
            headerRowData = this.getFieldData(headerRow, sheetData);
            firstRow = +Math.max(...headerRow) + 1 + +ignoreRows;
        } else {
            headerRowData = sheetData[headerRow];
            firstRow = +headerRow + 1 + +ignoreRows;
        }

        const selectedFields = dataIn.selectedFields !== undefined ? dataIn.selectedFields : headerRowData;
        const structure = this.structureService.getStructureByKey(modul, dataIn.structureKey);
        const targetData: Array<any> = [];

        if (!structure) {
            return targetData;
        } else {
            for (let i = firstRow; i < sheetData.length; i++) {
                const row = sheetData[i];
                const obj = this.transformRow(row, headerRowData, selectedFields, structure);
                if (this.rowIsEmpty(obj)) {
                    continue;
                }
                obj.tid = 0;
                targetData.push(obj);
            }
            return targetData;
        }
    }

    rowIsEmpty(row: any) {
        return !Object.keys(row).find((k: string) => row[k] !== undefined);
    }

    transformRow(row: Array<string>, headerRow: Array<string>, selectedFields: any, structure: any) {
        const obj: any = {};
        const names = Array.isArray(selectedFields) ? selectedFields : Object.keys(selectedFields);
        names.forEach((n) => {
            const idx = headerRow.indexOf(n);
            const target = selectedFields[n];
            const value = row[idx];
            if (target && target.trim() !== '') {
               // console.log('transform: ' + target + ' = ' + value);
                obj[target] = this.transformValue(value, target, structure);
            }
        });
        return obj;
    }

    transformValue(value: any, target: string, structure: any) {
        const att = structure.ATTS.find((a: any) => a.KEY === target );
        if (att) {
           if (att.TYPE === 'DATE') {
                const num = ((+value - (25567 + 2)) * 86400); // ACHTUNG, EXCEL-DATUM,
                                                              // + 2 wg. sog. Leap-Year-Bug von Excel (sollte eigentlich nur + 1 sein ...)
                if (Number.isNaN(num)) {
                    value = undefined;
                } else {
                    value = num;
                }
                // console.log(target + ' = ' + value);
           } else if (att.TYPE === 'DOUBLE' || att.TYPE === 'FLOAT') {
                if (value && value !== '' && isNaN(+value)) {
                    const posPunkt = (value + '').indexOf('.');
                    const posKomma = (value + '').indexOf(',');
                    if (posPunkt === -1 && posKomma > -1) {
                        // Nur Komma
                        value = +((value + '').replace(',', '.'));
                    } else if (posPunkt > -1 && posKomma > -1) {
                        // Punkt und Komma
                        value = +((value + '').replace('.', '').replace(',', '.'));
                    }
                }
           }
        }
        return value;
    }

    getFieldData(headerRow: any, sheetData: any) {
        let fieldRows: any = '';
        let fieldData: Array<any> = [];
        if (headerRow.length > 1) {
            for ( let j = 0; j < sheetData[headerRow[0]].length; j++) {
                for ( let k = 0; k < headerRow.length; k++) {
                    fieldRows = fieldRows + sheetData[k][j] + ' ';
                }
                fieldData.push(fieldRows.trim());
                fieldRows = '';
            }
        } else {
            fieldData = sheetData[headerRow];
        }
        return fieldData;
    }
}
// ***************************** IMPORT ROUTINEN ENDE ***********************************
